import isEmpty from 'lodash/isEmpty';
import { useQuery } from '@apollo/client';

import { FilteredSpecialsDocument } from 'src/gql/graphql';
import type { Specials, Products } from 'src/gql/graphql';

export type ProductOffersInput = Pick<Products, 'DispensaryID' | 'specialData'>;

export default function useProductOffers(product: ProductOffersInput): { specials: Specials[]; loading: boolean } {
  const { data, loading } = useQuery(FilteredSpecialsDocument, {
    skip: isEmpty(product.specialData?.bogoSpecials),
    variables: {
      specialsFilter: {
        dispensaryId: product.DispensaryID,
        current: true,
        specialIds: (product.specialData?.bogoSpecials ?? [])
          .map((s) => s?.specialId)
          .filter((id): id is string => id != null),
      },
    },
  });

  const specials = (data?.filteredSpecials?.specials ?? []).filter((s): s is Specials => s != null);

  return { specials, loading };
}
